$(document).ready(function () {
  $("ul.droplink").on("click", ".init", function () {
    $(this).closest("ul.droplink").find('ul').toggle();
  });

  var allOptions = $("ul.droplink").children("li:not(.init)");
  $("ul.droplink").on("click", "li:not(.init)", function () {
    allOptions.removeClass("selected");
    $(this).addClass("selected");
    $("ul.droplink").children(".init").html($(this).html());
    $(".button_redirect a").removeClass("btn-disabled").attr('href',$(this).attr('data-link'));
    $("ul.droplink").find('ul').toggle();
  });
});

$(document).on('click','.more-button',function() {
  $(this).parents('.expandable_content_wrapper').find('.content-description').hide();
  $(this).parents('.expandable_content_wrapper').find('.moretext').show();
});

$(document).on('click','.less-button',function() {
  $(this).parents('.expandable_content_wrapper').find('.moretext').hide();
  $(this).parents('.expandable_content_wrapper').find('.content-description').show();
  $('html, body').animate({
    scrollTop: $(".expandable_content_wrapper").offset().top - 150
  }, 500);
});

// The theme temporarily uses open="false" while an accordion closes. If the
// Description body was expanded with Read More, its inline sizing can prevent
// transitionend from removing that attribute, so every later click is treated
// as another close. Normalize only the product Description accordion.
document.addEventListener('click', function(event) {
  var trigger = event.target.closest(
    '.product-accordion--description [data-collapsible-trigger]'
  );
  if (!trigger) return;

  var details = trigger.closest('[data-collapsible]');
  if (!details) return;

  // Allow an immediate reopen even when the previous close animation did not
  // finish its open="false" cleanup.
  if (details.getAttribute('open') === 'false') {
    details.removeAttribute('open');
  }

  window.setTimeout(function() {
    if (details.getAttribute('open') !== 'false') return;

    details.removeAttribute('open');

    var body = details.querySelector('[data-collapsible-body]');
    var content = details.querySelector('.desc-rm-content');
    var button = details.querySelector('.desc-rm-btn');

    if (body) {
      body.style.height = '';
      body.style.maxHeight = '';
      body.style.overflow = '';
    }

    if (content) {
      content.setAttribute('data-expanded', 'false');
      content.style.maxHeight = '';
      content.style.webkitMaskImage = '';
      content.style.maskImage = '';
      content.style.overflow = '';
    }

    if (button) {
      button.textContent = 'Read More';
      button.setAttribute('aria-expanded', 'false');
    }
  }, 400);
}, true);

$(document).on('click','.droptotext_Content .text_with_drop .droplink ul li',function() {
  var data_dropdown = $(this).attr('data-dropdown');
  $(this).parents('.droptotext_Content').find('.dropdown_content_inner .descriptive_text').addClass('hidden');
  $(this).parents('.droptotext_Content').find('.dropdown_content_inner .descriptive_text[data-dropdown_content="'+data_dropdown+'"]').removeClass('hidden');
});

// CWI NK
$(document).on('click','.multi_tabs_block_section .multi_tabs_block_main .tab_title',function(){
  var data_title = $(this).attr('data_title');  
  $(this).parents('.multi_tabs_block_main').find('.single_tab_data_main').addClass('hidden');
  $(this).parents('.multi_tabs_block_main').find('.single_tab_data_main[data_title="'+data_title+'"]').removeClass('hidden');
  $('.cource_faq_section').parents('.shopify-section').addClass('hidden');
  $('.cource_faq_section.' + $(this).attr('for-faq')).parents('.shopify-section').removeClass('hidden');
});

$(document).ready(function(){
  $('.multi_tabs_block_section .multi_tabs_block_main .tab_title.default_open').click();
});

// if($('.infinite_slide_change .logos__slider__outer .logos__slider .logos__slide').length){
//   $('.infinite_slide_change .logos__slider__outer .logos__slider').each(function(currentIndex,elem){
//     setInterval(function(){
//       $(elem).find('.logos__slide').eq(currentIndex).click();
//       currentIndex = currentIndex + 1;
//       if(currentIndex >= $(elem).find('.logos__slide').length){
//         currentIndex = 0;
//       }
//     }, 2500);
//   });
// }

// CWI CODE A
$('.accordion-section collapsible-elements .accordion .accordion__title.default_trigger_click').click();

function normalizeClosedFaqDetails(scope) {
  (scope || document).querySelectorAll('.dearist-faq-cards details[open="false"], #Faq--faqs_product_zYQ9En details[open="false"]').forEach(function(details) {
    details.removeAttribute('open');
  });
}

document.addEventListener('DOMContentLoaded', function() {
  normalizeClosedFaqDetails(document);
});

document.addEventListener('click', function(event) {
  const trigger = event.target.closest('.dearist-faq-cards details summary, .dearist-faq-cards details .accordion__title, #Faq--faqs_product_zYQ9En details summary, #Faq--faqs_product_zYQ9En details .accordion__title');
  if (!trigger) return;

  const details = trigger.closest('details');
  if (details && details.getAttribute('open') === 'false') {
    details.removeAttribute('open');
  }

  window.setTimeout(function() {
    normalizeClosedFaqDetails(document);
  }, 0);
}, true);

document.addEventListener('click', function(event) {
  const link = event.target.closest('[data-review-summary-link]');
  if (!link) return;

  const target = document.querySelector('#judgeme_product_reviews, .jdgm-review-widget');
  if (!target) return;

  event.preventDefault();
  target.scrollIntoView({ behavior: 'smooth', block: 'start' });
});

// Desktop product mosaic: show only the currently selected variant image and
// place it at the first gallery position. Mobile keeps the theme's native
// slider order and behaviour.
function initDesktopVariantMedia(scope) {
  (scope || document).querySelectorAll('product-images').forEach(function(gallery) {
    var list = gallery.querySelector('[data-product-media-list]');
    if (!list || list.dataset.variantMediaOrderReady === 'true') return;

    var slides = Array.from(list.querySelectorAll(':scope > [data-slide]'));
    slides.forEach(function(slide, index) {
      slide.dataset.originalMediaPosition = index;
    });
    list.dataset.variantMediaOrderReady = 'true';

    function restoreOriginalOrder() {
      var utility = list.querySelector(':scope > .slider__arrows');
      slides
        .slice()
        .sort(function(a, b) {
          return Number(a.dataset.originalMediaPosition) - Number(b.dataset.originalMediaPosition);
        })
        .forEach(function(slide) {
          list.insertBefore(slide, utility || null);
        });
    }

    function positionActiveVariant(mediaId) {
      restoreOriginalOrder();
      if (!window.matchMedia('(min-width: 750px)').matches) return;

      var active = mediaId
        ? list.querySelector('[data-media-id="' + CSS.escape(mediaId) + '"][data-variant-media]')
        : list.querySelector('[data-variant-media].media--active');

      if (active) list.prepend(active);
    }

    gallery.addEventListener('theme:media:select', function(event) {
      window.requestAnimationFrame(function() {
        positionActiveVariant(event.detail && event.detail.id);
      });
    });

    window.addEventListener('resize', function() {
      positionActiveVariant(gallery.getAttribute('data-active-media'));
    });

    positionActiveVariant(gallery.getAttribute('data-active-media'));
  });
}

document.addEventListener('DOMContentLoaded', function() {
  initDesktopVariantMedia(document);
});

function initDearistVideoCarousels(scope) {
  (scope || document).querySelectorAll('[data-video-carousel]').forEach(function(carousel) {
    if (carousel.dataset.videoCarouselReady === 'true') return;

    const track = carousel.querySelector('[data-video-carousel-track]');
    const slides = Array.from(carousel.querySelectorAll('.dearist-video-carousel__slide'));
    const dots = Array.from(carousel.querySelectorAll('[data-video-carousel-dot]'));
    const prev = carousel.querySelector('[data-video-carousel-prev]');
    const next = carousel.querySelector('[data-video-carousel-next]');

    if (!track || slides.length === 0) return;

    carousel.dataset.videoCarouselReady = 'true';

    function activeIndex() {
      const trackLeft = track.getBoundingClientRect().left;
      let closestIndex = 0;
      let closestDistance = Infinity;

      slides.forEach(function(slide, index) {
        const distance = Math.abs(slide.getBoundingClientRect().left - trackLeft);
        if (distance < closestDistance) {
          closestDistance = distance;
          closestIndex = index;
        }
      });

      return closestIndex;
    }

    function updateDots() {
      const index = activeIndex();
      dots.forEach(function(dot, dotIndex) {
        dot.classList.toggle('is-active', dotIndex === index);
      });
    }

    function scrollToIndex(index) {
      const targetIndex = Math.max(0, Math.min(slides.length - 1, index));
      const trackRect = track.getBoundingClientRect();
      const slideRect = slides[targetIndex].getBoundingClientRect();
      const scrollLeft = track.scrollLeft + (slideRect.left - trackRect.left);
      track.scrollTo({ left: scrollLeft, behavior: 'smooth' });
    }

    function updateDotsForIndex(index) {
      const clamped = Math.max(0, Math.min(slides.length - 1, index));
      dots.forEach(function(dot, dotIndex) {
        dot.classList.toggle('is-active', dotIndex === clamped);
      });
    }

    if (prev) {
      prev.addEventListener('click', function() {
        const newIndex = Math.max(0, activeIndex() - 1);
        scrollToIndex(newIndex);
        updateDotsForIndex(newIndex);
      });
    }

    if (next) {
      next.addEventListener('click', function() {
        const newIndex = Math.min(slides.length - 1, activeIndex() + 1);
        scrollToIndex(newIndex);
        updateDotsForIndex(newIndex);
      });
    }

    track.addEventListener('scroll', function() {
      window.requestAnimationFrame(updateDots);
    }, { passive: true });

    track.addEventListener('scrollend', function() {
      updateDots();
    }, { passive: true });

    // Prevent page from scrolling vertically when user swipes horizontally on carousel
    var touchStartX = 0;
    var touchStartY = 0;
    track.addEventListener('touchstart', function(e) {
      touchStartX = e.changedTouches[0].clientX;
      touchStartY = e.changedTouches[0].clientY;
    }, { passive: true });

    track.addEventListener('touchmove', function(e) {
      var dx = Math.abs(e.changedTouches[0].clientX - touchStartX);
      var dy = Math.abs(e.changedTouches[0].clientY - touchStartY);
      if (dx > dy && dx > 5) {
        e.preventDefault();
      }
    }, { passive: false });

    updateDots();
  });
}

document.addEventListener('DOMContentLoaded', function() {
  initDearistVideoCarousels(document);
  initDearistFormulaCarousels(document);
  initDearistUgcCarousels(document);
  initReviewReadMore(document);
});

document.addEventListener('shopify:section:load', function(event) {
  initReviewReadMore(event.target);
});

function initReviewReadMore(scope) {
  (scope || document).querySelectorAll('[data-review-text]').forEach(function(text) {
    var button = text.parentElement.querySelector('[data-review-read-more]');
    if (!button) return;

    function updateButton() {
      if (text.classList.contains('is-expanded')) {
        button.hidden = false;
        return;
      }

      button.hidden = text.scrollHeight <= text.clientHeight + 1;
    }

    if (button.dataset.reviewReadMoreReady !== 'true') {
      button.dataset.reviewReadMoreReady = 'true';
      button.addEventListener('click', function() {
        var expanded = text.classList.toggle('is-expanded');
        button.setAttribute('aria-expanded', expanded ? 'true' : 'false');
        button.textContent = expanded ? 'read less' : '…read more';
      });
    }

    requestAnimationFrame(updateButton);
    window.addEventListener('resize', updateButton);
  });
}

function initDearistFormulaCarousels(scope) {
  (scope || document).querySelectorAll('[data-formula-carousel]').forEach(function(carousel) {
    if (carousel.dataset.formulaCarouselReady === 'true') return;
    carousel.dataset.formulaCarouselReady = 'true';

    var track = carousel.querySelector('[data-formula-carousel-track]');
    var slides = Array.from(carousel.querySelectorAll('[data-formula-slide]'));
    var dots = Array.from(carousel.querySelectorAll('[data-formula-dot]'));
    var prevBtn = carousel.querySelector('[data-formula-prev]');
    var nextBtn = carousel.querySelector('[data-formula-next]');

    if (!track || slides.length === 0) return;

    var currentIndex = 0;

    function goTo(index) {
      currentIndex = Math.max(0, Math.min(slides.length - 1, index));
      // Use rendered slide width + CSS gap (16px) to calculate transform offset.
      // getBoundingClientRect().width is precise even with fractional px from calc().
      var slideWidth = slides[0].getBoundingClientRect().width;
      var gap = 16;
      var offset = currentIndex * (slideWidth + gap);
      track.style.transform = 'translateX(-' + offset + 'px)';
      dots.forEach(function(dot, i) {
        dot.classList.toggle('is-active', i === currentIndex);
      });
    }

    if (prevBtn) prevBtn.addEventListener('click', function() { goTo(currentIndex - 1); });
    if (nextBtn) nextBtn.addEventListener('click', function() { goTo(currentIndex + 1); });

    dots.forEach(function(dot) {
      dot.addEventListener('click', function() {
        goTo(parseInt(dot.dataset.formulaDot, 10));
      });
    });

    // Touch swipe — advance index on release; no page-scroll interference
    var swipeStartX = 0;
    carousel.addEventListener('touchstart', function(e) {
      swipeStartX = e.changedTouches[0].clientX;
    }, { passive: true });
    carousel.addEventListener('touchend', function(e) {
      var dx = e.changedTouches[0].clientX - swipeStartX;
      if (Math.abs(dx) > 40) {
        goTo(currentIndex + (dx < 0 ? 1 : -1));
      }
    }, { passive: true });

    // Hover right peeking zone → advance slide
    // Zone-entry approach: timer is set once on zone entry, not reset on every mousemove
    var viewport = carousel.querySelector('.dearist-formula-carousel__viewport');
    if (viewport) {
      var hoverTimer = null;
      var inAdvanceZone = false;

      viewport.addEventListener('mousemove', function(e) {
        var rect = viewport.getBoundingClientRect();
        var ratio = (e.clientX - rect.left) / rect.width;
        var nowInZone = ratio > 0.65;

        if (nowInZone && !inAdvanceZone) {
          // Just entered the peeking zone — start the advance timer once
          inAdvanceZone = true;
          hoverTimer = setTimeout(function() {
            goTo(currentIndex + 1);
            inAdvanceZone = false; // reset so re-entering zone can advance again
          }, 200);
        } else if (!nowInZone && inAdvanceZone) {
          // Left the zone before timer fired — cancel
          inAdvanceZone = false;
          clearTimeout(hoverTimer);
        }
      });

      viewport.addEventListener('mouseleave', function() {
        inAdvanceZone = false;
        clearTimeout(hoverTimer);
      });
    }

    // Recalculate on resize so offset stays correct with new slide widths
    window.addEventListener('resize', function() { goTo(currentIndex); });

    goTo(0);
  });
}

function initDearistUgcCarousels(scope) {
  (scope || document).querySelectorAll('[data-ugc-carousel]').forEach(function(carousel) {
    if (carousel.dataset.ugcCarouselReady === 'true') return;
    carousel.dataset.ugcCarouselReady = 'true';

    var track = carousel.querySelector('[data-ugc-track]');
    var slides = Array.from(carousel.querySelectorAll('[data-ugc-slide]'));
    var dots = Array.from(carousel.querySelectorAll('[data-ugc-dot]'));
    var prevBtn = carousel.querySelector('[data-ugc-prev]');
    var nextBtn = carousel.querySelector('[data-ugc-next]');

    if (!track || slides.length === 0) return;

    var currentIndex = 0;

    function goTo(index) {
      currentIndex = Math.max(0, Math.min(slides.length - 1, index));
      var slideWidth = slides[0].getBoundingClientRect().width;
      var gap = 12;
      var offset = currentIndex * (slideWidth + gap);
      track.style.transform = 'translateX(-' + offset + 'px)';
      dots.forEach(function(dot, i) {
        dot.classList.toggle('is-active', i === currentIndex);
      });
    }

    if (prevBtn) prevBtn.addEventListener('click', function() { goTo(currentIndex - 1); });
    if (nextBtn) nextBtn.addEventListener('click', function() { goTo(currentIndex + 1); });

    dots.forEach(function(dot) {
      dot.addEventListener('click', function() {
        goTo(parseInt(dot.dataset.ugcDot, 10));
      });
    });

    var swipeStartX = 0;
    carousel.addEventListener('touchstart', function(e) {
      swipeStartX = e.changedTouches[0].clientX;
    }, { passive: true });
    carousel.addEventListener('touchend', function(e) {
      var dx = e.changedTouches[0].clientX - swipeStartX;
      if (Math.abs(dx) > 40) goTo(currentIndex + (dx < 0 ? 1 : -1));
    }, { passive: true });

    window.addEventListener('resize', function() { goTo(currentIndex); });
    goTo(0);
  });
}
